export const navigateLeftId = 'receipt-navigate-left';
export const navigateRightId = 'receipt-navigate-right';
